// keep in sync with api/models/Interaction.ts
export enum EventType {
  S2_ANNOTATION = 's2_annotation',
  UI_INTERACTION = 'ui_interaction',
  UI_STATE = 'ui_state',
  WIDGET_DATA_VOYAGER = 'widget_data_voyager',
  WIDGET_TABLE = 'widget_table',
  WIDGET_REPORT = 'widget_report',
  WIDGET_PAPER_FINDER = 'widget_paper_finder',
  WIDGET_PAPER_FINDER_TEXT_FEEDBACK = 'widget_paper_finder_text_feedback',
  WIDGET_PAPER_FINDER_REACTION = 'widget_paper_finder_reaction',
  WIDGET_TABLE_RELATED_PAPERS = 'widget_table_related_papers',
  WIDGET_TABLE_ADD_RELATED_PAPERS = 'widget_table_add_related_papers',
  WIDGET_REPORT_SECTION_TEXT_FEEDBACK = 'widget_report_section_text_feedback',
  WIDGET_REPORT_SECTION_TEXT_REACTION = 'widget_report_section_text_reaction',
  WIDGET_REPORT_SECTION_TABLE_FEEDBACK = 'widget_report_section_table_feedback',
  WIDGET_REPORT_SECTION_TABLE_REACTION = 'widget_report_section_table_reaction',
  WIDGET_PAPER_FINDER_PAPER_FEEDBACK = 'widget_paper_finder_paper_feedback',
  WIDGET_PAPER_FINDER_PAPER_REACTION = 'widget_paper_finder_paper_reaction',
}

export interface InteractionEvent {
  type: EventType;
  text?: string;
  data?: Record<string, unknown>;
  messageId?: string;
  threadId?: string;
  channelId?: string;
}
